import React, { createContext, useContext, useState } from "react";
import businessService from "~/services/businessService";
import _ from "lodash";
import { DialogBuilder } from "~/utils/DialogProvider";
import { useTranslation } from "react-i18next";
import { retryRequest } from "~/utils/retryUtils";

const ContractContext = createContext();

export const ContractProvider = ({ children}) => {
    const { t } = useTranslation();
    const [contract, setContract] = useState({});
    const dialog = useContext(DialogBuilder);

    const loadContract = async (businessId) => {
        try {
            const { data } = await retryRequest(
                businessService.getContract,
                [businessId],
                3,
                1000,
                "Contract"
            );
            
            localStorage.setItem("@prit-web/contract", JSON.stringify(data));
            setContract(data);
            return data;
        } catch (error) {
            console.error("All retry attempts failed. Showing error dialog.");
            if (dialog && t) {
                dialog
                    .withTitle("Error")
                    .withMessage(t("Error loading contract information"))
                    .withButtonText(t("Try again"))
                    .withAction(() => {
                        localStorage.removeItem("@prit-web/contract");
                        setContract({});
                        loadContract(businessId);
                    })
                    .show();
            }
        }
    }

    const getContract = () => {
        const savedContract = localStorage.getItem("@prit-web/contract");
        if (!_.isEmpty(savedContract)) {
            return JSON.parse(savedContract);
        }
        return contract;
    }

    return (
        <ContractContext.Provider value={{ contract, loadContract, getContract}}>
            {children}
        </ContractContext.Provider>
    )
}

export const useContract = () => {
    const context = useContext(ContractContext);
    if (_.isEmpty(context)) {
        throw new Error("useContract must be used within a ContractProvider");
    }
    return context;
}